import "./index.css";
import Button from "../button";
import { useState,useEffect } from "react";
import { uploadImageForIdea } from "../../functions/uploadImageForIdea";
import { createIdeaImageWithAI } from "../../functions/createIdeaImageWithAI";

function ImageModule({ display, functionForButton, image, id }) {
  const [isError, SetIsError] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageToDisplay,setImageToDisplay] = useState(image);

  useEffect(() => {
      setImageToDisplay(image);
}, [image]);

console.log(image);

  const handleClick = async (id) => {
    console.log("hello!");
    let canCreateImage = await createIdeaImageWithAI(SetIsError,SetErrorMessage,id);
    if(canCreateImage){
      console.log(canCreateImage);
      setImageToDisplay(`${canCreateImage}`);
    }
  };

const uploadImage = async (file) => {
  if (!file) {
    SetIsError(true);
    SetErrorMessage("No file selected");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("id", id);

  let canUpload = await uploadImageForIdea(SetIsError, SetErrorMessage, formData);
  if (canUpload) {
    setImageToDisplay(URL.createObjectURL(file));
  }
};


  const handleClose = () => {
    functionForButton();
    SetIsError(false);
    SetErrorMessage("");
  };

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  setSelectedFile(file);
  await uploadImage(file);
};

const downloadImage = async (id) => {
  if (!imageToDisplay) {
    SetIsError(true);
    SetErrorMessage("No image available to download.");
    return;
  }

  try {
    const isLocal = imageToDisplay.includes("mako_image_uploads");
    const filename = imageToDisplay.split("/").pop() || `image-${id}.png`;

    if (isLocal) {
      // Download from your backend route
      const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/downloadImage/${filename}`;
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // External image: fetch as blob and trigger download
      const response = await fetch(imageToDisplay, { mode: 'cors' });
      if (!response.ok) throw new Error("Failed to fetch external image");

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }
  } catch (err) {
    console.error("Download failed:", err);
    SetIsError(true);
    SetErrorMessage("Download failed. Please try again.");
  }
};





  return (
    <div id="image-blur-wrapper" style={{ display: display }}>
      <div id="image-creation-module">
        <div className="input-module-title-holder">
          <h2 className="big-text">Image creator</h2>
          <img alt="close" src="./images/close.png" onClick={handleClose} />
        </div>

        <div className="small-text description">Create and store images for this content</div>
        <img id="stored-image" src={imageToDisplay}   style={{ display: imageToDisplay ? "block" : "none" }} alt="Stored" />

        

        {isError && <div id="error-message">{errorMessage}</div>}
      <Button text="Download image" addedFunction={downloadImage} params={id}></Button>
      <div className="image-button-holder">
        <label htmlFor="file-upload">
          <Button text="Choose image" />
        </label>
        <input
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <Button text="Create image" addedFunction={handleClick} params={id} />
      </div>
      </div>
    </div>
  );
}

export default ImageModule;